import React from "react";

const defaultCustomerComplaintData = [
  {
    topic: "Data privacy",
    currentReceived: "",
    currentPending: "",
    previousReceived: "",
    previousPending: "",
    currentRemarks: "",
    previousRemarks: "",
  },
  {
    topic: "Advertising",
    currentReceived: "",
    currentPending: "",
    previousReceived: "",
    previousPending: "",
    currentRemarks: "",
    previousRemarks: "",
  },
  {
    topic: "Cyber-security",
    currentReceived: "",
    currentPending: "",
    previousReceived: "",
    previousPending: "",
    currentRemarks: "",
    previousRemarks: "",
  },
  {
    topic: "Delivery of essential services",
    currentReceived: "",
    currentPending: "",
    previousReceived: "",
    previousPending: "",
    currentRemarks: "",
    previousRemarks: "",
  },

  {
    topic: "Restrictive Trade Practices",
    currentReceived: "",
    currentPending: "",
    previousReceived: "",
    previousPending: "",
    currentRemarks: "",
    previousRemarks: "",
  },
  {
    topic: "Unfair Trade Practices",
    currentReceived: "",
    currentPending: "",
    previousReceived: "",
    previousPending: "",
    currentRemarks: "",
    previousRemarks: "",
  },
  {
    topic: "Other",
    currentReceived: "",
    currentPending: "",
    previousReceived: "",
    previousPending: "",
    currentRemarks: "",
    previousRemarks: "",
  },
];

const CustomerComplaintsTable = ({ complaintData, setComplaintData }) => {
  const handleChange = (index, field, value) => {
    const updated = [...complaintData];
    updated[index][field] = value;
    setComplaintData(updated);
  };

  const cell = {
    border: "1px solid #000",
    padding: "15px",
    textAlign: "center",
    verticalAlign: "middle",
  };

  const leftCell = {
    ...cell,
    textAlign: "left",
    fontWeight: "bold",
    backgroundColor: "#d3c9ce",
  };

  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
  };

  const inputStyle = {
    width: "100%",
    padding: "25px",
    border: "1px solid gray",
    borderRadius: "4px",
    fontSize: "14px",
    textAlign: "center",
  };

  return (
    <div
      style={{
        overflowX: "auto",
        marginTop: 20,
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={header} rowSpan={2}>
              Topic
            </th>
            <th style={header} colSpan={3}>
              Current Financial Year
            </th>
            <th style={header} colSpan={3}>
              Previous Financial Year
            </th>
          </tr>
          <tr>
            <th style={header}>Received during the year</th>
            <th style={header}>Pending resolution</th>
            <th style={header}>Remarks</th>
            <th style={header}>Received during the year</th>
            <th style={header}>Pending resolution</th>
            <th style={header}>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {complaintData.map((row, index) => (
            <tr key={index}>
              <td style={leftCell}>{row.topic}</td>
              <td style={cell}>
                <input
                  type="text"
                  placeholder="Number"
                  value={row.currentReceived}
                  onChange={(e) =>
                    handleChange(index, "currentReceived", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={cell}>
                <input
                  type="text"
                  placeholder="Number"
                  value={row.currentPending}
                  onChange={(e) =>
                    handleChange(index, "currentPending", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={cell}>
                <input
                  type="text"
                  placeholder="Remarks"
                  value={row.currentRemarks}
                  onChange={(e) =>
                    handleChange(index, "currentRemarks", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={cell}>
                <input
                  type="text"
                  placeholder="Number"
                  value={row.previousReceived}
                  onChange={(e) =>
                    handleChange(index, "previousReceived", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={cell}>
                <input
                  type="text"
                  placeholder="Number"
                  value={row.previousPending}
                  onChange={(e) =>
                    handleChange(index, "previousPending", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={cell}>
                <input
                  type="text"
                  placeholder="Remarks"
                  value={row.previousRemarks}
                  onChange={(e) =>
                    handleChange(index, "previousRemarks", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CustomerComplaintsTable;
